var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    {
      staticClass: "px-6 pt-6 pb-0",
      attrs: { id: "reports-dashboard", fluid: "" }
    },
    [
      _c(
        "v-row",
        { staticClass: "fill-height pb-3" },
        [
          _c(
            "v-col",
            { staticClass: "py-0 pr-3", attrs: { cols: "12", md: "6" } },
            [
              _c(
                "v-skeleton-loader",
                {
                  attrs: {
                    type: "image",
                    "max-height": "400",
                    loading: _vm.isFetchingData
                  }
                },
                [
                  _c(
                    "v-card",
                    { staticClass: "pull-up" },
                    [
                      _c(
                        "v-card-title",
                        { staticClass: "overline pb-6 d-flex justify-start" },
                        [
                          _c("h3", [
                            _vm._v(
                              "Cantidad de interrupciones de servicio eléctrico CORPOELEC"
                            )
                          ])
                        ]
                      ),
                      _c(
                        "v-card-text",
                        {
                          staticClass: "d-flex justify-center",
                          attrs: { collapse: "", show: "" }
                        },
                        [
                          _c("apexchart", {
                            staticClass: "dashboard-chart",
                            attrs: {
                              type: "bar",
                              options: _vm.monthInterruptionOptions,
                              series: _vm.monthInterruptionSeries
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-col",
            {
              class:
                "pa-0 " + (_vm.$vuetify.breakpoint.smAndDown ? "pt-3" : ""),
              attrs: { cols: "12", md: "6" }
            },
            [
              _c(
                "v-container",
                { staticClass: "pa-0", attrs: { fluid: "" } },
                [
                  _c(
                    "v-row",
                    { staticClass: "pa-0 ma-0" },
                    _vm._l(_vm.dataCenterDisponibilityCharts, function(
                      dataCenterDisponibilityChart
                    ) {
                      return _c(
                        "v-col",
                        {
                          key: dataCenterDisponibilityChart.id,
                          staticClass: "backup-availability pt-0 pl-3",
                          attrs: { cols: "12", md: "6" }
                        },
                        [
                          _c("card-radial-bar-chart", {
                            attrs: {
                              title: dataCenterDisponibilityChart.title,
                              cardColor: dataCenterDisponibilityChart.cardColor,
                              chartColor:
                                dataCenterDisponibilityChart.chartColor,
                              fontColor: dataCenterDisponibilityChart.fontColor
                            }
                          })
                        ],
                        1
                      )
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "v-skeleton-loader",
                {
                  staticClass: "px-3 pt-3",
                  attrs: {
                    type: "image",
                    "max-width": "auto",
                    "max-height": "120",
                    loading: _vm.isFetchingData
                  }
                },
                [
                  _c(
                    "v-card",
                    { staticClass: "pull-up", attrs: { "fill-height": "" } },
                    [
                      _c(
                        "v-card-title",
                        {
                          staticClass: "overline d-flex justify-center",
                          staticStyle: { color: "#464855" }
                        },
                        [
                          _c("h3", { staticClass: "text-center" }, [
                            _vm._v(
                              " Duración promedio de las interrupciones de CORPOELEC "
                            ),
                            _c("div", { staticClass: "hidden-md-and-down" }, [
                              _vm._v("en el mes actual")
                            ])
                          ])
                        ]
                      ),
                      _c("v-card-text", [
                        _c(
                          "div",
                          [
                            _c(
                              "v-row",
                              { staticClass: "pb-1" },
                              _vm._l(_vm.monthInterruptionSummary, function(
                                dataCenterInterruption
                              ) {
                                return _c(
                                  "v-col",
                                  {
                                    key: dataCenterInterruption.id,
                                    staticClass:
                                      "text-center pa-0 ma-0 card-dashboard-details",
                                    attrs: { cols: "12", md: "6" }
                                  },
                                  [
                                    _c("card-interruption-time-average", {
                                      attrs: {
                                        dataCenter: dataCenterInterruption.name,
                                        timeAverage:
                                          dataCenterInterruption.timeAverage,
                                        timeDifference:
                                          dataCenterInterruption.timeDifference
                                      }
                                    })
                                  ],
                                  1
                                )
                              }),
                              1
                            )
                          ],
                          1
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-row",
        { staticClass: "fill-height" },
        [
          _c(
            "v-col",
            { attrs: { lg: "5", md: "5", sm: "12" } },
            [
              _c(
                "v-skeleton-loader",
                {
                  staticClass: "mx-auto",
                  attrs: { type: "image", loading: _vm.isFetchingData }
                },
                [
                  _c("quarter-summary-card-content", {
                    attrs: {
                      quarterHumidityReport:
                        _vm.quarterSummaryContent.quarterHumidityReport,
                      quarterTemperatureReport:
                        _vm.quarterSummaryContent.quarterTemperatureReport
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { lg: "4", md: "4", cols: "12" } },
            [_c("environmental-control-system-availability")],
            1
          ),
          _c(
            "v-col",
            { attrs: { lg: "3", md: "3", cols: "12" } },
            [
              _c(
                "v-skeleton-loader",
                {
                  staticClass: "mx-auto",
                  attrs: { type: "image", loading: this.isFetchingData }
                },
                [
                  _c("quarter-interruption-summary", {
                    attrs: {
                      quarterIncidentsReport:
                        _vm.quarterSummaryContent.quarterIncidentsReport
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-row",
        { staticClass: "fill-height pb-3" },
        _vm._l(_vm.environmentControlOptions, function(
          environmentChartOptions
        ) {
          return _c(
            "v-col",
            {
              key: environmentChartOptions.dataCenter.id,
              attrs: { cols: "12", md: "6" }
            },
            [
              _c(
                "v-skeleton-loader",
                {
                  staticClass: "mx-auto",
                  attrs: { type: "image", loading: _vm.isFetchingData }
                },
                [
                  _c("environmental-control-chart", {
                    attrs: {
                      name: environmentChartOptions.dataCenter.name,
                      temperatureOptions:
                        environmentChartOptions.dataCenter.temperature,
                      humidityOptions:
                        environmentChartOptions.dataCenter.humidity
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        }),
        1
      ),
      _c(
        "v-snackbar",
        {
          attrs: { top: "", color: "error" },
          model: {
            value: _vm.loadingError,
            callback: function($$v) {
              _vm.loadingError = $$v
            },
            expression: "loadingError"
          }
        },
        [
          _vm._v(
            " Ocurrió un error obteniendo los reportes, por favor cargue la página de nuevo "
          ),
          _c(
            "v-btn",
            {
              attrs: { color: "white", text: "" },
              on: {
                click: function($event) {
                  _vm.loadingError = false
                }
              }
            },
            [_vm._v("Cerrar")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }